import { ProfileContext } from '../../contexts/ProfileContext';
import { useContext, useEffect } from 'react';
import ContentWrapper from '../../components/common/wrappers/ContentWrapper';
import HomeBoardImage from '../../components/common/home/HomeBoardImage';
import HomeCodeInput from '../../components/common/home/HomeCodeInput';
import HomeLink from '../../components/common/home/HomeLink';
import HomeLogo from '../../components/common/home/HomeLogo';
import PageWrapper from '../../components/common/wrappers/PageWrapper';

export default function Home() {
    const { clearProfile } = useContext(ProfileContext);

    useEffect(() => {
        window.localStorage.clear();
        clearProfile();
    });
    return (
        <PageWrapper>
            <div className="game-screen splash-screen">
                <ContentWrapper>
                    <HomeLogo />
                    <HomeCodeInput />
                    <HomeBoardImage />
                    <HomeLink />
                    <div className="recaptcha-infoText">
                        Tato aplikace je chráněna reCAPTCHA a Google{' '}
                        <a href="https://policies.google.com/privacy">Zásadami ochrany osobních údajů</a> a platí{' '}
                        <a href="https://policies.google.com/terms">Smluvní podmínky</a>.
                    </div>
                </ContentWrapper>
            </div>
        </PageWrapper>
    );
}
